import React from 'react';
import PropTypes from 'prop-types';

import StepTitle from '../StepTitle';
import CheckoutProtectionPlans from './components/CheckoutProtectionPlans';

const Protection = ({
  goToTab,
  avoCheckoutStepCompleted,
  cart,
  getCartIssues,
  calculateTotal,
  client,
}) => (
  <>
    <div className="flex flex-row flex-wrap justify-between items-start">
      <StepTitle
        number="4"
        caption="When an accident happens, know your investment is protected."
      >
        Protection Plans
      </StepTitle>
    </div>

    <CheckoutProtectionPlans
      avoCheckoutStepCompleted={avoCheckoutStepCompleted}
      calculateTotal={calculateTotal}
      cart={cart}
      client={client}
      getCartIssues={getCartIssues}
      goToTab={goToTab}
    />
  </>
);

Protection.propTypes = {
  calculateTotal: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  getCartIssues: PropTypes.func.isRequired,
  goToTab: PropTypes.func.isRequired,
  avoCheckoutStepCompleted: PropTypes.func.isRequired,
};

export default Protection;
